package br.com.texeratx.boardgametimeapp.data.repository

import br.com.texeratx.boardgametimeapp.core.network.ApiClient
import br.com.texeratx.boardgametimeapp.core.session.SessionManager
import br.com.texeratx.boardgametimeapp.data.model.dashboard.DashboardResponse
import io.ktor.client.call.*

class DashboardRepository(
    private val api: ApiClient,
    private val sessionManager: SessionManager
) {

    suspend fun getDashboard(): Result<DashboardResponse> {
        return try {
            // Verifica sessão
            val session = sessionManager.load()
                ?: return Result.failure(Exception("Sessão expirada"))

            // Faz requisição
            val httpResponse = api.get("stats/dashboard")

            // Desserializa a resposta
            val dto: DashboardResponse = httpResponse.body()

            Result.success(dto)

        } catch (e: Exception) {
            Result.failure(e)
        }
    }
}
